<template functional>
    <li :data-date="props.revision.created_at | date_format('DD.MM YYYY')">
        <article class="timeline-item">
            <b-alert v-if="props.previousRevision" show variant="warning">
                <b>{{ parent.$t('Break: {0} min', [ parent.$moment(props.previousRevision.created_at).diff(props.revision.created_at, 'minutes')]) }}</b>
            </b-alert>

            <header>
                <small class="font-weight-bold">{{ props.revision.created_at | time }}</small>

                <b-breadcrumb v-if="props.revision.breadcrumb">
                    <b-breadcrumb-item
                        v-for="breadcrumb in props.revision.breadcrumb"
                        :key="breadcrumb.url"
                        :active="!breadcrumb.url"
                        :aria-current="null"
                        :html="breadcrumb.text"
                        :href="breadcrumb.url"
                    />
                </b-breadcrumb>
            </header>

            <p v-html="props.revision.message" />
        </article>
    </li>
</template>
<script>
    export default {
        name: 'RevisionHistoryItem',
        props: {
            revision: {
                type: Object,
                required: true
            },
            previousRevision: {
                type: Object,
                default: null
            },
        }
    }
</script>
